import { Component, computed, inject, input, signal } from '@angular/core';
import { MD_DIALOG_REF, MDDialogModule, MDDialogRef, MDIconComponent, MDTagComponent, MDContentBoxComponent } from '@melodic-ui/components';
import { GradeTagComponent } from '../../grade-tag/grade-tag.component';
import { IndicatorType } from '@melodic-ui/types';
import { AccountStateService } from '@lb/state/account-state.service';
import { DividerComponent } from '@lb/components/divider/divider.component';

export interface IProjectFinalGrade {
	gradeName: string | null;
	gradeColor: IndicatorType;
}

export interface ISaveFinalProjectCriteriaItem {
	criteriaName: string;
	gradeName: string | null;
	gradeColor: IndicatorType;
}

export interface ISaveFinalReviewResult {
	attendanceStatusID: number | null;
	generateInvoice: boolean;
}

@Component({
	selector: 'lb-save-final-review-dialog',
	standalone: true,
	imports: [MDDialogModule, MDIconComponent, MDTagComponent, GradeTagComponent, MDContentBoxComponent, DividerComponent],
	templateUrl: './save-final-review-dialog.component.html',
	styleUrl: './save-final-review-dialog.component.scss'
})
export class SaveFinalReviewDialogComponent {
	private readonly dialogRef = inject<MDDialogRef>(MD_DIALOG_REF);
	private readonly accountState = inject(AccountStateService);

	projectCriteriaItems = input<ISaveFinalProjectCriteriaItem[]>([]);
	projectGrade = input<IProjectFinalGrade | null>(null);
	currentAttendanceStatusID = input<number | null>(null);

	generateInvoice = signal<boolean>(true);

	isAdmin = this.accountState.isAdmin;

	hasProjectCriteria = computed(() => this.projectCriteriaItems().length > 0);
	isAttendanceTaken = computed(() => this.currentAttendanceStatusID() != null);

	confirm(): void {
		const result: ISaveFinalReviewResult = {
			attendanceStatusID: this.isAttendanceTaken() ? null : 1, // If attendance is already taken, we won't change it. If not, we'll set it to "Present" (1).
			generateInvoice: this.isAdmin() ? this.generateInvoice() : true
		};
		this.dialogRef.close(result);
	}

	close(): void {
		this.dialogRef.close(null);
	}
}
